// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';
import { useOfferService } from 'services/OfferService';

import { StyledIcon } from '../../../checkout-styled-components';
import PromoCodeAlertMessage from '../PromoCodeAlertMessage/PromoCodeAlertMessage';

import {
  PromoCodeCardContainer,
  StyledAlertButton,
  StyledAlertMessage,
} from './styled-components';

// Other

export const renderMessage = (setAddPromoCodeVisibility) => (
  <PromoCodeAlertMessage
    setAddPromoCodeVisibility={setAddPromoCodeVisibility}
  />
);
const PromoCodeCard = ({ setAddPromoCodeVisibility }) => {
  const { layout } = useWindowDimensions();

  const offerService = useOfferService();
  const hasPromoCode = offerService.isPromoCode && offerService.hasActiveOffer;

  return (
    <PromoCodeCardContainer isMobile={layout === DIMENSIONS.MOBILE}>
      {hasPromoCode
        ? (
          <StyledAlertMessage
            align="center"
            cursor="auto"
            display="flex"
            fontSize="14px"
            icon={<StyledIcon aria-hidden role="presentation" type="tag" />}
            justify="space-between"
            message={`${offerService.offerName} promo applied!`}
            showIcon
            data-testid="offerAttached"
          />
        )

        : (
          <StyledAlertButton>
            <StyledAlertMessage
              align="center"
              cursor="pointer"
              display="flex"
              fontSize="14px"
              icon={<StyledIcon role="presentation" type="tag" />}
              justify="space-between"
              message={renderMessage(setAddPromoCodeVisibility)}
              canAddOffer={!hasPromoCode}
              showIcon
            />
          </StyledAlertButton>
        )}
    </PromoCodeCardContainer>
  );
};

PromoCodeCard.propTypes = {
  setAddPromoCodeVisibility: PropTypes.func,
};

export default PromoCodeCard;
